module.exports = __webpack_public_path__ + "media/images/flip_white-367a1b72fb95b5629c99a153b402ebe5.svg";